import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import validateForm from '../../helpers/validateform';

import { UserService } from '../../services/user.service';
import { EncryptionService } from '../../services/encryption.service';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent implements OnInit {
  resetPwd!: FormGroup;
  submitted = false;
  errorMessage: string = '';
  successMessage: string = '';
  lang: any;
  token: any;

  passwordRegx = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,50}$/;

  constructor(private formBuilder: FormBuilder, private router: Router, private translate: TranslateService, private user: UserService, private route: ActivatedRoute, private en: EncryptionService) { }

  ngOnInit(): void {
    this.translate.addLangs(['en', 'jp']);

    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      this.lang = localStorage.getItem('site_lang') ?? 'jp';
      localStorage.setItem('site_lang', this.lang);
      this.translate.use(this.lang);
    }

    const params = this.route.snapshot.queryParams;
    this.token = decodeURIComponent(params['token'] || '');
    if (params['lang']) {
      this.lang = params['lang'];
      this.translate.use(this.lang);
    }

    this.resetPwd = this.formBuilder.group({
        newPassword: ['', [Validators.required, Validators.pattern(this.passwordRegx)]],
        retypeNewPassword: ['', [Validators.required]]
      },
      { validator: this.passwordMatchValidator }
      );
    }
    get f() { return this.resetPwd.controls; }
    
  passwordMatchValidator(form: AbstractControl) {
    const newPassword = form.get('newPassword')?.value;
    const retypeNewPassword = form.get('retypeNewPassword')?.value;

    if (newPassword !== retypeNewPassword) {
      form.get('retypeNewPassword')?.setErrors({ mismatch: true });
    } else {
      const errors = form.get('retypeNewPassword')?.errors;
      if (errors) {
        delete errors['mismatch'];
        if (Object.keys(errors).length === 0) {
          form.get('retypeNewPassword')?.setErrors(null);
        }
      }
    }
    return null;
  }
  resetPwdFrm() {
    this.submitted = true;
      // console.log(this.resetPwd.value.password);
      if (this.resetPwd.invalid) {
        validateForm.validateAllFormFields(this.resetPwd);
        alert(this.translate.instant('PleaseFillFormCorrectly'));     
        return;
      }
      
      const payLoad = {
        "token": this.token, 
        "newPassword": this.en.encryptUsingAES256(this.resetPwd.value.newPassword),
        "retypeNewPassword": this.en.encryptUsingAES256(this.resetPwd.value.retypeNewPassword)
      }
      // console.log(payLoad);
      // return;
      this.user.restPassword(payLoad, this.lang)
        .subscribe({
          next: (res: any) => {
            if (res.status) {
              this.successMessage = res.message;
              this.errorMessage = '';
              alert(res.message);
              this.router.navigate(['login']);
            } else {
              this.errorMessage = res.message;
              this.successMessage = '';
              alert(res.message);
            } 
          },
          error: (err: any) => {
            this.errorMessage = err.message;
            this.successMessage = '';
          }
      })
      
    }
}
